import { createSelector } from 'reselect';
import { sortBy } from 'lodash';
import moment from 'moment';

const getAllNotifications = state => state.notifications.notifications;
const getNotViewedNotifications = state => state.notifications.notViewedNotifications;
const getServerDateTime = state => state.statics.serverDateTime;

const calculateDays = (notifications, serverDateTime) => notifications && notifications.map((notification) => {
  return {
    ...notification,
    days: moment(serverDateTime).startOf('day').diff(moment(notification.created).startOf('day'), 'days'),
  };
});

export const mapAllNotificationsDays = createSelector(
  [getAllNotifications, getServerDateTime],
  (notifications, serverDateTime) => calculateDays(notifications, serverDateTime)
);

export const mapFilteredNotificationsDays = createSelector(
  [getNotViewedNotifications, getServerDateTime],
  (notifications, serverDateTime) => calculateDays(notifications, serverDateTime)
);
